import {
  File,
  FileSpreadsheet,
  FileText,
  Folder,
  FolderOpen,
  Link,
  Presentation,
} from 'lucide-react'
import type { SidebarTreeIcon } from './sidebar-tree.types'

export function resolveSidebarTreeIcon(icon: SidebarTreeIcon | undefined, expanded = false) {
  if (!icon) {
    return <File className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
  }
  if (typeof icon === 'object' && 'lucide' in icon) {
    const Lucide = icon.lucide
    return <Lucide className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
  }
  switch (icon) {
    case 'folder':
      return <Folder className="h-3.5 w-3.5 shrink-0 text-yellow-500/80" />
    case 'folder-open':
      return <FolderOpen className="h-3.5 w-3.5 shrink-0 text-yellow-500/80" />
    case 'gdoc':
      return <FileText className="h-3.5 w-3.5 shrink-0 text-blue-500" />
    case 'gsheet':
      return <FileSpreadsheet className="h-3.5 w-3.5 shrink-0 text-green-600" />
    case 'gslides':
      return <Presentation className="h-3.5 w-3.5 shrink-0 text-amber-500" />
    case 'gshortcut':
      return <Link className="h-3.5 w-3.5 shrink-0 text-purple-400" />
    case 'md':
      return <FileText className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
    case 'file':
    default:
      return <File className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
  }
}

export function sidebarTreeIconForMime(mimeType: string, isFolder: boolean, expanded = false): SidebarTreeIcon {
  if (isFolder) return expanded ? 'folder-open' : 'folder'
  if (mimeType === 'application/vnd.google-apps.shortcut') return 'gshortcut'
  if (mimeType.includes('document') || mimeType.includes('word')) return 'gdoc'
  if (mimeType.includes('spreadsheet') || mimeType.includes('excel')) return 'gsheet'
  if (mimeType.includes('presentation') || mimeType.includes('powerpoint')) return 'gslides'
  if (mimeType.includes('markdown') || mimeType.endsWith('/md')) return 'md'
  return 'file'
}
